import React from 'react';
import LazyLoad from 'react-lazyload';

interface LazyImageProps {
  lazyLoad?: boolean;
  alt: string;
  src: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}
const LazyImage: React.FC<LazyImageProps> = (props) => {
  const { lazyLoad = true, ...imgProps } = props;
  if (lazyLoad) {
    return (
      <LazyLoad
        once
        className="lazy-image-wrapper"
        placeholder={<img width={imgProps.width} height={imgProps.height} />}
      >
        <img {...imgProps} />
      </LazyLoad>
    );
  } else {
    return <img {...imgProps} />;
  }
};

export default LazyImage;
